import { BaseObject } from "../business-objects/base-object/base-object.model";
import { AccountObject } from "../../vas/business-objects/account-object/account-object.model";

export const isAccountObject = (entityInstance: BaseObject): entityInstance is AccountObject => {
    return entityInstance instanceof AccountObject;
}



// WEBPACK FOOTER //
// ./src/core/util/is-account-object.ts